module.exports = __webpack_public_path__ + "img/robot.5bf61320.png";